module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('w-mask', {
    attrs: {
      "is-show": _vm.isShow
    },
    on: {
      "click": _vm.hide
    }
  }, [_c('transition', {
    attrs: {
      "name": "bottom"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShow),
      expression: "isShow"
    }],
    staticClass: "mgm-share-box"
  }, [_c('div', {
    staticClass: "mgm-share-box-title"
  }, [_vm._v("\n                立即邀请好友\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "wui-border-1px wui-border-b mgm-share-box-tools"
  }, [_c('w-row', [_c('w-cell', {
    attrs: {
      "width": "72"
    },
    on: {
      "click": _vm.openQr
    }
  }, [_c('w-col', [_c('w-cell', {
    attrs: {
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "mgm-share-item"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/imgs/share-qr@2x.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('w-cell', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("\n                                当面扫码\n                            ")])], 1)], 1), _vm._v(" "), _c('w-cell', {
    attrs: {
      "width": "72"
    }
  }, [_c('w-col', {
    staticClass: "w-clipboard-data-text",
    attrs: {
      "data-clipboard-text": _vm.options.url
    }
  }, [_c('w-cell', {
    attrs: {
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "mgm-share-item"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/imgs/share-link@2x.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('w-cell', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("\n                                复制链接\n                            ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mgm-share-box-targets"
  }, [_c('w-row', [_c('w-cell', {
    attrs: {
      "width": "72"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.shareTo('0')
      }
    }
  }, [_c('w-col', [_c('w-cell', {
    attrs: {
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "mgm-share-item"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/imgs/share-wechat@2x.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('w-cell', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("\n                                微信好友\n                            ")])], 1)], 1), _vm._v(" "), _c('w-cell', {
    attrs: {
      "width": "72"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.shareTo('1')
      }
    }
  }, [_c('w-col', [_c('w-cell', {
    attrs: {
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "mgm-share-item"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/imgs/share-wechat-area@2x.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('w-cell', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("\n                                朋友圈\n                            ")])], 1)], 1), _vm._v(" "), _c('w-cell', {
    attrs: {
      "width": "72"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.shareTo('2')
      }
    }
  }, [_c('w-col', [_c('w-cell', {
    attrs: {
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "mgm-share-item"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/imgs/share-qq@2x.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('w-cell', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("\n                                QQ\n                            ")])], 1)], 1), _vm._v(" "), _c('w-cell', {
    attrs: {
      "width": "72"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.shareTo('3')
      }
    }
  }, [_c('w-col', [_c('w-cell', {
    attrs: {
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "mgm-share-item"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/imgs/share-qzone@2x.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('w-cell', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("\n                                QQ空间\n                            ")])], 1)], 1)], 1)], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12295e58"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/utils/components/share.vue
// module id = 245
// module chunks = 93